
































import MeditationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/MeditationResponse";
import MeditationNotesFilter from "@models/meditations/meditationNotesFilter";
import MeditationNotesModel from "@models/meditations/meditationNotesModel";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({ name: "meditation-notes-modal" })
export default class MeditationNotesModalComponent extends Vue {
  @Prop() dialog: boolean;
  @Prop() data: MeditationResponse;

  @Watch("data", { deep: true })
  dataUpdated(data: MeditationResponse) {
    this.filter.MeditationId = data?.Id ?? null;
  }

  filter: MeditationNotesFilter = new MeditationNotesFilter();
  columnNames = ["Пользователь", "Комментарий", "Рейтинг"];

  /** Заголовок таблицы */
  get title(): string {
    if (!!this.data)
      return `Комментарии к медитации: ${this.$options.filters.translations(
        this.data.Translations.filter((_) => _.LangCode == "RU"),
        "Name"
      )}`;
    return null;
  }

  async getMeditationNotesByIdAsync(filter: any) {
    return await this.$api.MeditationService.getMeditationNotesByIdAsync(filter);
  }
}
